<div class="response__container">
  <ng-container *ngFor="let section of groupedResponses">
    <app-responses-section [section]="section">

    </app-responses-section>
  </ng-container>
</div>